import React from 'react'
import PropTypes from 'prop-types'

const ChannelIntro = (props) => {

  return (
    <div className='card border-light mb-5'>
      <h2>{props.title}</h2>
      <p className='lead'>{props.subtitle}</p>
      <p>{props.summary}</p>
    </div>
  )
}

ChannelIntro.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
}

export default ChannelIntro
